import { z } from 'zod';

export const stateOptionSchema = z.object({
  id: z.string(),
  code: z.string(),
  name: z.string(),
});
export type StateOption = z.infer<typeof stateOptionSchema>;
